import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
/* eslint-env browser */
import * as React from 'react';
import { usePopper } from 'react-popper';
import { Layer } from '../Helper';
import { isNode } from '../../helpers';
import { useUpdateEffect } from '../../hooks';
import DropDownContext from './DropDownContext';
function reducer(state, action) {
  var firstIndex = 0;
  var lastIndex = state.itemsRefs.length - 1;
  switch (action.type) {
    case 'open':
      return _objectSpread(_objectSpread({}, state), {}, {
        visible: true
      });
    case 'close':
      return _objectSpread(_objectSpread({}, state), {}, {
        visible: false,
        index: -1
      });
    case 'toggle':
      return _objectSpread(_objectSpread({}, state), {}, {
        visible: !state.visible
      });
    case 'openAtFisrtItem':
      return _objectSpread(_objectSpread({}, state), {}, {
        visible: true,
        index: firstIndex
      });
    case 'openAtLastItem':
      return _objectSpread(_objectSpread({}, state), {}, {
        visible: true,
        index: lastIndex
      });
    case 'selectItemAt':
      return _objectSpread(_objectSpread({}, state), {}, {
        index: action.index
      });
    case 'selectFirstItem':
      return _objectSpread(_objectSpread({}, state), {}, {
        index: firstIndex
      });
    case 'selectLastItem':
      return _objectSpread(_objectSpread({}, state), {}, {
        index: lastIndex
      });
    case 'selectNextItem':
      {
        var next = state.index + 1;
        if (next > lastIndex) next = firstIndex;
        return _objectSpread(_objectSpread({}, state), {}, {
          index: next
        });
      }
    case 'selectPrevItem':
      {
        var prev = state.index - 1;
        if (prev < firstIndex) prev = lastIndex;
        return _objectSpread(_objectSpread({}, state), {}, {
          index: prev
        });
      }
    default:
      throw new Error();
  }
}
var initialState = {
  visible: false,
  index: -1
};
var defaultModifiers = [{
  name: 'offset',
  options: {
    offset: [0, 1]
  }
}];
function DropDownContainer(_ref) {
  var id = _ref.id,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'auto' : _ref$placement,
    _ref$modifiers = _ref.modifiers,
    modifiers = _ref$modifiers === void 0 ? defaultModifiers : _ref$modifiers,
    renderReference = _ref.renderReference,
    children = _ref.children,
    onChange = _ref.onChange;
  var itemsRefs = React.useRef([]);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    referenceElement = _React$useState2[0],
    setReferenceElement = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    popperElement = _React$useState4[0],
    setPopperElement = _React$useState4[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
      placement: placement,
      modifiers: _toConsumableArray(modifiers)
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;

  // $FlowFixMe[incompatible-call]
  var _React$useReducer = React.useReducer(reducer, _objectSpread(_objectSpread({}, initialState), {}, {
      itemsRefs: itemsRefs.current
    })),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    state = _React$useReducer2[0],
    dispatch = _React$useReducer2[1];
  useUpdateEffect(function () {
    if (typeof onChange === 'function') {
      onChange(state.visible);
    }
  }, [onChange, state.visible]);
  React.useEffect(function () {
    if (itemsRefs.current[state.index]) {
      itemsRefs.current[state.index].focus({
        preventScroll: true
      });
    }
  }, [state.index]);

  /**
   * Handle click events outside of the Popover.
   */
  var handleClickOutside = React.useCallback(function (evt) {
    if (!state.visible) {
      return;
    }
    if (isNode(referenceElement) && referenceElement.contains(evt.target) || isNode(popperElement) && popperElement.contains(evt.target)) {
      return;
    }
    dispatch({
      type: 'close'
    });
  }, [popperElement, referenceElement, state.visible]);
  React.useEffect(function () {
    document.addEventListener('click', handleClickOutside, false);
    return function () {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, [handleClickOutside]);
  var handleClick = function handleClick(evt) {
    evt.preventDefault();
    dispatch({
      type: 'toggle'
    });
  };

  /**
   * https://www.w3.org/TR/wai-aria-practices-1.1/#keyboard-interaction-13
   */
  var handleKeydown = function handleKeydown(evt) {
    switch (evt.key) {
      case 'Enter':
      case 'SpaceBar':
      case ' ':
      case 'ArrowDown':
        evt.preventDefault();
        dispatch({
          type: 'openAtFisrtItem'
        });
        break;
      case 'ArrowUp':
        evt.preventDefault();
        dispatch({
          type: 'openAtLastItem'
        });
        break;
      case 'Escape':
        evt.preventDefault();
        dispatch({
          type: 'close'
        });
        break;
      default:
    }
  };
  var context = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispatch: dispatch,
      referenceElement: referenceElement
    });
  }, [state, dispatch, referenceElement]);
  return /*#__PURE__*/React.createElement(DropDownContext.Provider, {
    value: context
  }, renderReference(
  // $FlowFixMe[cannot-spread-inexact]
  function (mergeProps) {
    return _objectSpread({
      'aria-haspopup': 'menu',
      'aria-controls': id,
      'aria-expanded': state.visible,
      innerRef: setReferenceElement,
      active: state.visible,
      onClick: handleClick,
      onKeyDown: handleKeydown
    }, mergeProps);
  }, state.visible), state.visible && /*#__PURE__*/React.createElement(Layer, null, children(
  // $FlowFixMe[cannot-spread-indexer]
  function (mergeProps) {
    return _objectSpread(_objectSpread({
      'aria-labelledby': id,
      innerRef: setPopperElement,
      style: styles.popper
    }, attributes.popper), mergeProps);
  }, state.visible)));
}
export default DropDownContainer;